/* ============================================
   INSEA - Scroll Reveal & Animation Controller
   ============================================ */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ============================
  // PARALLAX EFFECT
  // ============================

  function initParallax() {
    // Skip on mobile
    if (window.innerWidth < 750) return;

    // Collect all parallax targets
    var targets = [];

    // Hero parallax
    document.querySelectorAll('.hero--parallax').forEach(function (hero) {
      var intensity = parseInt(getComputedStyle(hero).getPropertyValue('--parallax-intensity')) || 20;
      var mediaGrid = hero.querySelector('.hero__media-grid');
      if (mediaGrid) {
        targets.push({ container: hero, element: mediaGrid, intensity: intensity });
      }
    });

    // Section parallax (split showcase, etc.)
    document.querySelectorAll('.section--parallax').forEach(function (section) {
      var intensity = parseInt(section.getAttribute('data-parallax-intensity')) || 20;
      section.querySelectorAll('.group-block__media-wrapper').forEach(function (media) {
        var img = media.querySelector('.background-image-container img');
        if (img) {
          targets.push({ container: section, element: img, intensity: intensity });
        }
      });
    });

    if (!targets.length) return;

    function updateParallax() {
      var viewHeight = window.innerHeight;

      targets.forEach(function (t) {
        var rect = t.container.getBoundingClientRect();

        // Only process if container is in or near viewport
        if (rect.bottom < -100 || rect.top > viewHeight + 100) return;

        var scale = 1 + t.intensity / 100;
        var progress = 1 - (rect.bottom / (viewHeight + rect.height));
        var maxTranslate = (t.intensity / 100) * rect.height * 0.5;
        var translateY = (progress - 0.5) * maxTranslate;

        t.element.style.transform = 'scale(' + scale + ') translateY(' + translateY + 'px)';
      });
    }

    // Use requestAnimationFrame for smooth performance
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Initial call
    updateParallax();
  }

  // ============================
  // VIDEO EFFECTS (Sticky / Reveal)
  // ============================

  function initVideoEffects() {
    if (window.innerWidth < 750) return;

    // --- Reveal on Scroll ---
    var revealHeroes = document.querySelectorAll('.hero--video-reveal');
    if (revealHeroes.length) {
      var revealTicking = false;

      function updateReveal() {
        var viewHeight = window.innerHeight;

        revealHeroes.forEach(function (hero) {
          var rect = hero.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewHeight) return;

          // Progress: 0 when hero enters bottom, 1 when fully in view
          var progress = Math.min(1, Math.max(0, 1 - (rect.top / (viewHeight * 0.6))));

          var mediaGrid = hero.querySelector('.hero__media-grid');
          if (!mediaGrid) return;

          if (progress >= 1) {
            hero.classList.add('reveal-complete');
          } else {
            hero.classList.remove('reveal-complete');
            // Animate from 30% inset to 0%
            var inset = 30 * (1 - progress);
            mediaGrid.style.clipPath = 'inset(' + inset + '% ' + inset + '% ' + inset + '% ' + inset + '%)';
          }
        });
      }

      window.addEventListener('scroll', function () {
        if (!revealTicking) {
          requestAnimationFrame(function () {
            updateReveal();
            revealTicking = false;
          });
          revealTicking = true;
        }
      }, { passive: true });

      updateReveal();
    }
  }

  const SECTION_SELECTOR = '.shopify-section > .section-background + .section';

  const COMPONENT_SELECTORS = [
    'marquee-component',
    '.resource-list',
    'slideshow-component',
  ];

  function shouldSkip(el) {
    const parent = el.closest('.shopify-section');
    if (!parent) return true;
    if (parent.querySelector('header-component')) return true;
    if (parent.querySelector('announcement-bar-component')) return true;
    return false;
  }

  function isHeroSection(el) {
    const parent = el.closest('.shopify-section');
    return parent && parent.querySelector('.hero');
  }

  function hasClass(el, cls) {
    return el.classList.contains(cls);
  }

  function addRevealClass(el, cls) {
    if (hasClass(el, cls) || hasClass(el, 'revealed')) return;
    el.classList.add(cls);
  }

  function initDarkSections() {
    // Detect sections using the dark color scheme (scheme-7)
    // Shopify renders: <div class="section color-scheme-7">
    document.querySelectorAll('.shopify-section').forEach((section) => {
      const colorEl = section.querySelector('.color-scheme-7');
      if (!colorEl) return;
      if (section.classList.contains('dark-section')) return;

      section.classList.add('dark-section');

      // Hero detection by class, not position
      if (section.querySelector('.hero') || section.classList.contains('hero-wrapper')) {
        section.classList.add('dark-section--hero');
      }
    });

    // Group consecutive dark sections into a wrapper for continuous gradient
    const allSections = Array.from(document.querySelectorAll('main .shopify-section, #MainContent .shopify-section, .shopify-section-group-template .shopify-section'));
    // Fallback: if none found, use all shopify-sections not in header/footer
    const sections = allSections.length > 0 ? allSections :
      Array.from(document.querySelectorAll('.shopify-section')).filter((s) =>
        !s.closest('.shopify-section-group-header-group') && !s.closest('.shopify-section-group-footer-group')
      );

    let currentGroup = [];

    function wrapGroup(group) {
      if (group.length < 2) return;
      // Check if already wrapped
      if (group[0].parentElement && group[0].parentElement.classList.contains('dark-sections-group')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'dark-sections-group';
      group[0].parentNode.insertBefore(wrapper, group[0]);
      group.forEach((s) => wrapper.appendChild(s));
    }

    sections.forEach((section, i) => {
      if (section.classList.contains('dark-section')) {
        currentGroup.push(section);
      } else {
        if (currentGroup.length >= 2) {
          wrapGroup(currentGroup);
        }
        currentGroup = [];
      }
    });
    // Handle trailing group
    if (currentGroup.length >= 2) {
      wrapGroup(currentGroup);
    }
  }

  function initScrollReveal() {
    // ============================
    // DARK SECTION DETECTION
    // ============================
    initDarkSections();

    // ============================
    // SECTION-LEVEL REVEALS
    // ============================

    // 1. Main section blocks
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (shouldSkip(section)) return;
      if (isHeroSection(section)) return;
      if (hasClass(section, 'scroll-reveal')) return;
      if (!isInViewport(section)) {
        section.classList.add('scroll-reveal');
      }
    });

    // 2. Standalone components
    document.querySelectorAll(COMPONENT_SELECTORS.join(', ')).forEach((el) => {
      if (shouldSkip(el)) return;
      if (hasClass(el, 'scroll-reveal')) return;
      if (!isInViewport(el)) {
        el.classList.add('scroll-reveal');
      }
    });

    // 3. Collection cards stagger
    document.querySelectorAll('.collection-list-grid, .collection-list__grid').forEach((grid) => {
      if (!hasClass(grid, 'scroll-reveal-stagger')) {
        grid.classList.add('scroll-reveal-stagger');
      }
      grid.querySelectorAll('.collection-card').forEach((card) => {
        if (hasClass(card, 'scroll-reveal')) return;
        if (!isInViewport(card)) {
          card.classList.add('scroll-reveal');
        }
      });
    });

    // 4. Image banners (not hero)
    document.querySelectorAll('.image-banner, .banner').forEach((banner) => {
      if (isHeroSection(banner)) return;
      if (hasClass(banner, 'scroll-reveal--scale')) return;
      if (!isInViewport(banner)) {
        banner.classList.add('scroll-reveal--scale');
      }
    });

    // ============================
    // TEXT ANIMATIONS
    // ============================

    // 5. Hero text — dramatic entrance
    document.querySelectorAll('.hero').forEach((hero) => {
      const headings = hero.querySelectorAll('h1, h2, .hero__title');
      headings.forEach((h) => addRevealClass(h, 'text-reveal-hero'));

      const subtexts = hero.querySelectorAll('p:not(.visually-hidden)');
      subtexts.forEach((p) => {
        if (p.textContent.trim().length > 5) {
          addRevealClass(p, 'text-reveal-body');
        }
      });

      const buttons = hero.querySelectorAll('.button, .btn, a[class*="button"]');
      buttons.forEach((btn) => addRevealClass(btn, 'text-reveal-cta'));

      // Mark hero container for stagger
      const container = hero.querySelector('.hero__container, .hero__content');
      if (container) container.classList.add('text-stagger-container');
    });

    // 6. Section headings — clip reveal with underline
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (shouldSkip(section)) return;
      if (isHeroSection(section)) return;

      // Find section-level headings (h2, h3 that are direct section titles)
      const sectionContent = section.querySelector('.section');
      if (!sectionContent) return;

      // Get ALL headings in the section that are not inside cards
      const headings = sectionContent.querySelectorAll('h2, h3');
      headings.forEach((h) => {
        if (h.closest('.product-card') || h.closest('.collection-card') || h.closest('.resource-card') || h.closest('.services-grid__card') || h.closest('.services-grid__header')) return;
        if (h.closest('cart-drawer-component')) return;
        if (hasClass(h, 'text-reveal-title') || hasClass(h, 'text-reveal-hero')) return;
        if (h.textContent.trim().length < 3) return;
        if (!isInViewport(h)) {
          addRevealClass(h, 'text-reveal-title');
          h.classList.add('text-reveal-underline');
        }
      });

      // Get ALL descriptive paragraphs (not inside cards)
      const paragraphs = sectionContent.querySelectorAll('p');
      paragraphs.forEach((p) => {
        if (p.closest('.product-card') || p.closest('.collection-card') || p.closest('.resource-card') || p.closest('.services-grid__card')) return;
        if (p.closest('.hero')) return;
        if (p.closest('cart-drawer-component')) return;
        if (p.closest('marquee-component')) return;
        if (hasClass(p, 'text-reveal-body') || hasClass(p, 'text-reveal-hero')) return;
        if (p.textContent.trim().length < 15) return;
        if (!isInViewport(p)) {
          addRevealClass(p, 'text-reveal-body');
        }
      });

      // Buttons in sections
      const buttons = sectionContent.querySelectorAll('.button, a[class*="button"]');
      buttons.forEach((btn) => {
        if (btn.closest('.product-card') || btn.closest('.collection-card') || btn.closest('.services-grid__card')) return;
        if (btn.closest('.hero')) return;
        if (btn.closest('cart-drawer-component')) return;
        if (hasClass(btn, 'text-reveal-cta')) return;
        if (!isInViewport(btn)) {
          addRevealClass(btn, 'text-reveal-cta');
        }
      });
    });

    // 7. "Preparate para el futuro" section — slide from sides
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (shouldSkip(section)) return;
      const content = section.querySelector('.section');
      if (!content) return;

      // Detect image-with-text / split layout sections
      const mediaEl = content.querySelector('deferred-media, video-background-component, .media, .image-with-text__media');
      const textEl = content.querySelector('.text-block, .rich-text__content, .image-with-text__content');
      if (mediaEl && textEl) {
        if (!isInViewport(mediaEl) && !hasClass(mediaEl, 'scroll-reveal--from-left')) {
          addRevealClass(mediaEl, 'scroll-reveal--from-left');
        }
        if (!isInViewport(textEl) && !hasClass(textEl, 'text-reveal-slide-right')) {
          // Animate text children individually
          const headings = textEl.querySelectorAll('h2, h3, p[class*="h"], .h1, .h2, .h3');
          headings.forEach((h) => {
            if (!hasClass(h, 'text-reveal-slide-right')) {
              addRevealClass(h, 'text-reveal-slide-right');
            }
          });
          const paras = textEl.querySelectorAll('p:not([class*="h"])');
          paras.forEach((p) => {
            if (p.textContent.trim().length > 10 && !hasClass(p, 'text-reveal-body')) {
              addRevealClass(p, 'text-reveal-body');
            }
          });
          const btns = textEl.querySelectorAll('.button, a[class*="button"]');
          btns.forEach((btn) => {
            if (!hasClass(btn, 'text-reveal-cta')) {
              addRevealClass(btn, 'text-reveal-cta');
            }
          });
        }
      }
    });

    // 8. Services grid — stagger cards and header with reveal
    document.querySelectorAll('.services-grid-wrapper').forEach((wrapper) => {
      // Header — remove text-reveal classes and use scroll-reveal instead
      const header = wrapper.querySelector('.services-grid__header');
      if (header) {
        header.querySelectorAll('.text-reveal-title, .text-reveal-body, .text-reveal-underline').forEach((el) => {
          el.classList.remove('text-reveal-title', 'text-reveal-body', 'text-reveal-underline');
        });
        if (!hasClass(header, 'scroll-reveal') && !isInViewport(header)) {
          header.classList.add('scroll-reveal');
        }
      }

      // Cards — stagger reveal
      wrapper.querySelectorAll('.services-grid__card').forEach((card, index) => {
        if (hasClass(card, 'scroll-reveal') || isInViewport(card)) return;
        card.classList.add('scroll-reveal');
        card.style.transitionDelay = (index * 0.1) + 's';
      });
    });

    // Clean up any text-reveal classes inside services-grid cards
    document.querySelectorAll('.services-grid__card .text-reveal-title, .services-grid__card .text-reveal-body, .services-grid__card .text-reveal-cta, .services-grid__card .text-reveal-underline').forEach((el) => {
      el.classList.remove('text-reveal-title', 'text-reveal-body', 'text-reveal-cta', 'text-reveal-underline');
    });

    // 9. FAQ section — stagger questions
    document.querySelectorAll('accordion-custom, .collapsible-content').forEach((accordion) => {
      const parent = accordion.closest('.section') || accordion.parentElement;
      if (parent && !hasClass(parent, 'faq-stagger') && !isInViewport(accordion)) {
        parent.classList.add('faq-stagger');
        // FAQ parent also needs reveal
        if (!hasClass(parent, 'scroll-reveal')) {
          // Don't add scroll-reveal here, faq-stagger handles its own animation
        }
      }
    });

    // 9. Contact form section — slide from left
    document.querySelectorAll('.shopify-section').forEach((section) => {
      const form = section.querySelector('form[action*="contact"]');
      if (!form) return;
      const content = section.querySelector('.section');
      if (!content || isInViewport(content)) return;

      // Title slides from left
      const headings = content.querySelectorAll('h2, h3, p.h2, p.h3');
      headings.forEach((h) => {
        if (!hasClass(h, 'text-reveal-slide-left')) {
          addRevealClass(h, 'text-reveal-slide-left');
        }
      });

      // Description fades up
      const paras = content.querySelectorAll('p:not(.h2):not(.h3)');
      paras.forEach((p) => {
        if (p.textContent.trim().length > 10 && !hasClass(p, 'text-reveal-body')) {
          addRevealClass(p, 'text-reveal-body');
        }
      });

      // Form itself scales up
      if (!hasClass(form, 'scroll-reveal--scale')) {
        addRevealClass(form, 'scroll-reveal--scale');
      }
    });

    // ============================
    // OBSERVER
    // ============================

    const animatedSelector = [
      '.scroll-reveal:not(.revealed)',
      '.scroll-reveal--from-left:not(.revealed)',
      '.scroll-reveal--from-right:not(.revealed)',
      '.scroll-reveal--scale:not(.revealed)',
      '.text-reveal-title:not(.revealed)',
      '.text-reveal-body:not(.revealed)',
      '.text-reveal-cta:not(.revealed)',
      '.text-reveal-hero:not(.revealed)',
      '.text-reveal-slide-left:not(.revealed)',
      '.text-reveal-slide-right:not(.revealed)',
      '.text-reveal-pop:not(.revealed)',
      '.faq-stagger:not(.revealed)',
    ].join(', ');

    // Primary observer — watches individual elements
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: '0px 0px -20px 0px',
      }
    );

    const allAnimated = document.querySelectorAll(animatedSelector);
    allAnimated.forEach((el) => observer.observe(el));

    // Section-level observer — reveals all animated children when parent section enters viewport
    // This catches elements that the primary observer misses (e.g. clip-path hidden elements)
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const unrevealed = entry.target.querySelectorAll(animatedSelector);
            unrevealed.forEach((el) => {
              el.classList.add('revealed');
              observer.unobserve(el);
            });
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.05,
        rootMargin: '0px 0px -30px 0px',
      }
    );

    // Observe sections that contain animated elements
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (section.querySelector(animatedSelector)) {
        sectionObserver.observe(section);
      }
    });
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  }

  function initAll() {
    initScrollReveal();
    initParallax();
    initVideoEffects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(initAll, 100);
  });
})();
